import { render, staticRenderFns } from "./PetRanking.vue?vue&type=template&id=b15c5cae&scoped=true"
import script from "./PetRanking.vue?vue&type=script&lang=js"
export * from "./PetRanking.vue?vue&type=script&lang=js"
import style0 from "./PetRanking.vue?vue&type=style&index=0&id=b15c5cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15c5cae",
  null
  
)

export default component.exports